module.exports = __webpack_public_path__ + "static/img/Air.adb43d01.png";